var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QResourceMenu',{attrs:{"links":_vm.links,"loading":_vm.loading,"error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }